import {
    fetch,
    uni
} from './index';

let headers = {
    'tokenType': '2'
};

/**
 * 添加评论
 * @param {*} query
 */
export function addComment (query) {
    return fetch({
        url: `${uni}/merchant/university/article/comment/add`,
        data: query,
        method: 'post',
        headers
    });
}

/**
 * 查询评论
 * @param {*} query
 */
export function queryCloudComments (query) {
    return fetch({
        url: `${uni}/merchant/university/article/comment/queryCloudComments`,
        data: query,
        method: 'post',
        headers
    });
}

/**
 * 评论点赞
 * @param {*} query
 */
export function commentGreat (query) {
    return fetch({
        url: `${uni}/merchant/university/article/comment/commentGreat`,
        data: query,
        method: 'post',
        headers
    });
}

/**
 * 查询教程
 * @param {*} query
 */
export function queryCourse (query, url) {
    return fetch({
        url: `${uni}/merchant/university/article/query/platform`,
        data: query,
        method: 'post',
        fromUrl: url,
        headers
    });
}

/**
 * 查询文章
 * @param {*} query
 */
export function queryArticle (query, url) {
    return fetch({
        url: `${uni}/merchant/university/article/query/condition`,
        data: query,
        method: 'post',
        fromUrl: url,
        headers
    });
}

/**
 * 文章推荐查询
 * @param {*} query
 */
export function queryRecommend (query) {
    return fetch({
        url: `${uni}/merchant/university/article/query/recommend`,
        data: query,
        method: 'post',
        headers
    });
}

/**
 * 点赞
 * @param {*} query
 */
export function greatUp (query) {
    return fetch({
        url: `${uni}/merchant/university/article/great`,
        data: query,
        method: 'post',
        headers
    });
}

/**
 * 查询banner
 * @param {*} query
 */
export function queryBanner () {
    return fetch({
        url: `${uni}/merchant/university/banner/query/platform`,
        headers
    });
}

/**
 * 文章详情查询
 * @param {*} query
 */
export function queryArticleDetail (query, url) {
    return fetch({
        url: `${uni}/merchant/university/article/query/id?articleId=${query}`,
        fromUrl: url,
        headers
    });
}

/**
 * 文章上下记录
 * @param {*} query
 */
export function queryArticlesAll (query) {
    return fetch({
        url: `${uni}/merchant/university/article/query/articles?articleId=${query}`,
        headers
    });
}

/**
 * 关键字联想查询
 * @param {*} query
 */
export function queryAssociatel (query) {
    return fetch({
        url: `${uni}/merchant/university/article/associate?associateWords=${query}`,
        headers
    });
}

/**
 * 推荐词列表
 * @param {*} query
 */
export function queryRecommends () {
    return fetch({
        url: `${uni}/merchant/university/article/recommend/queryRecommends`,
        headers
    });
}
